export default __webpack_public_path__ + "static/media/iconExit.3ecb5359.svg";